import React from 'react';
import { useSocketIoConnection } from './connection-provider';
import type { MessageHandlers } from './events';

/**
 * Subscribe to messages sent from the Socket IO server.
 * 
 * Usage:
 * ```
  const useQuiz = () => {
    const listener: ReceivingMessages = {
      event: PLAYER_JOINED_EVENT,
      callback: React.useCallback((p) => {}, []),
    };
    useSubscribe(listener);
  };
  ```
 */
export function useSubscribe(
  { event, callback }: MessageHandlers,
  shouldSubscribe = true,
) {
  const { connection } = useSocketIoConnection();

  React.useEffect(() => {
    if (!shouldSubscribe) return;
    if (!connection?.socket) return;
    connection.socket?.on(event, callback);
    return () => void connection.socket?.off(event, callback);
  }, [event, callback, connection?.socket, shouldSubscribe]);
}
